module.exports = __webpack_public_path__ + "img/mimeal2.194a64d8.png";